import { render } from "./ImportantNote.vue?vue&type=template&id=f4bb1712&scoped=true"
import script from "./ImportantNote.vue?vue&type=script&lang=js"
export * from "./ImportantNote.vue?vue&type=script&lang=js"

import "./ImportantNote.vue?vue&type=style&index=0&id=f4bb1712&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4bb1712"]])

export default __exports__